import React from "react";
import BlogContent from "@/components/Blogs/SingleBlog/BlogContent";
import FreeAppraisal from "@/components/Common/FreeAppraisal";
import { createClient } from "../../../../prismicio";
import Metadata from "@/components/Metadata";
import Layout from "@/components/Layout";

const Media = ({ passPage, pageAll, parms, globals }) => {
  let recentBlog = [];
  let dateFormatD;
  let dateFormatM;
  let dateFormatY;
  let metaDataTitle;
  let metaDataDesc;
  let metaDataImage;
  let prevUid;
  let nextUid;

  const commonComponents = globals?.data;

  {
    pageAll?.map(({ data, uid, last_publication_date }, idx) => {
      if (parms === uid) {
        var date = new Date(last_publication_date);
        dateFormatD = date.getDay();
        dateFormatM = date.toLocaleString("default", { month: "long" });
        dateFormatY = date.getFullYear();
        metaDataTitle = data?.metadata_title;
        metaDataDesc = data?.metadata_desc;
        metaDataImage = data?.metadata_image?.url;
        if (idx - 1 >= 0) {
          prevUid = pageAll[idx - 1]?.uid;
        }
        if (idx + 1 <= pageAll.length - 1) {
          nextUid = pageAll[idx + 1]?.uid;
        }
      }

      if (idx < 3) {
        recentBlog.push({
          image: data?.image,
          title: data?.title,
          buttonLink: "/media-coverage/" + uid,
        });
      }
    });
  }

  const value = {
    dateD: dateFormatD,
    dateM: dateFormatM,
    dateY: dateFormatY,
    passPage: passPage,
    recentBlog: recentBlog,
  };

  return (
    <Layout data={commonComponents}>
      <Metadata
        title={metaDataTitle}
        description={metaDataDesc}
        image={metaDataImage}
        path={`/media-coverage/${parms}`}
      />
      <BlogContent
        data={value}
        prevUid={prevUid}
        nextUid={nextUid}
        parentPage="media-coverage"
      />
      <FreeAppraisal page={`Blog - ${passPage?.title}`} />
      <div style={{ height: "40px" }}></div>
    </Layout>
  );
};

export default Media;

export async function getStaticProps({ params, previewData }) {
  const client = createClient({ previewData });
  const enPage = await client.getByUID(
    "media_coverage_individual_page",
    params.media,
  );
  const pageAll = await client.getAllByType("media_coverage_individual_page");
  const globals = await client.getSingle("globals");
  const passPage = enPage.data;
  const parms = params.media;
  return {
    props: { passPage, pageAll, parms, globals },
  };
}

export async function getStaticPaths() {
  const client = createClient();
  const pages = await client.getAllByType("media_coverage_individual_page");
  const paths = pages.map((page) => {
    return { params: { media: page.uid } };
  });

  return {
    paths,
    fallback: false,
  };
}
